export default __webpack_public_path__ + "static/media/paymesLogo.441b2d66.svg";